/** Product IDs must match the products created in App Store Connect and Play Console. */
export const STORE_PRO_PRODUCTS = {
  apple: 'com.drawonamap.pro.monthly',
  google: 'pro_monthly',
} as const;
export type PurchaseStore = keyof typeof STORE_PRO_PRODUCTS;
export const STORE_APP_ID = 'com.drawonamap.app';
export const STORE_USER_AGENT = 'DrawOnAMapNative/1';

export function isNativePurchaseRequest(request: Request): boolean {
  return request.headers.get('User-Agent')?.includes(STORE_USER_AGENT) === true
    || request.headers.get('X-DrawOnAMap-Native') === '1';
}
